import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll window
    window.scrollTo(0, 0);

    // Scroll container nếu có
    const mainContainer = document.querySelector('#scrollableDiv'); // Đổi class phù hợp
    if (mainContainer) {
      mainContainer.scrollTop = 0;
    }
  }, [pathname]); // Scroll mỗi khi URL thay đổi
};

export default useScrollToTop;
